import * as React from 'react'
import { SVGProps } from 'react'
const SvgQuestionBulletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 4h6M5 7l3-3-3-3" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export default SvgQuestionBulletIcon
